import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { adoptSolarIncentives } from "./solar-incentive-dependents"
import type {
  SolarProposalIncentivesDto,
  UpdateSolarProposalIncentivesDto,
} from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Saves the selected incentives and the payees the seller chose. */
export default function useUpdateSolarProposalIncentives(): UseMutationResult<
  SolarProposalIncentivesDto,
  unknown,
  { proposalId: string; body: UpdateSolarProposalIncentivesDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      solarProposalService.putIncentives(proposalId, body),
    onSuccess: (incentives, { proposalId }) => {
      adoptSolarIncentives(queryClient, proposalId, incentives)
    },
  })
}
